import { createFileRoute } from '@tanstack/react-router'
import { lazyLoadedComponent } from '#lib/routing/lazy-loaded-component'

export const Route = createFileRoute('/_dashboard/$account/settings')({
  staticData: { title: 'Settings' },

  component: lazyLoadedComponent(
    () => import('#app/pages/settings/account-layout/account-settings-layout'),
    'AccountSettingsLayout',
  ),
})
